import {get} from "../js/api";
import {useEffect, useState} from "react";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import {Overview} from "../view/orders/Overview";
import {UpdateOrder} from "../view/orders/UpdateOrder";
import {addDirtyListener} from "../js/main";
import {useChangeEffect} from "../js/util";

export const Orders = () => {

    const [orders, setOrders] = useState(null);
    const [selectedYear, setSelectedYear] = useState();

    const location = useLocation();
    const history = useHistory();

    const init = () => {
        get("/orders?year=" + selectedYear).then(resp => {
            setOrders(resp);
        });
    };

    useEffect(() => {
        var params = new URLSearchParams(location.search);
        const filter = params.get("selectedYear");

        if(filter){
            setSelectedYear(+filter);
        }  else {
           setSelectedYear(new Date().getFullYear())
        }
    }, []);

    useChangeEffect(() => {
        init();
        addDirtyListener(init);
        addSearch("selectedYear", selectedYear);
    }, [selectedYear]); // eslint-disable-line react-hooks/exhaustive-deps


    const addSearch = (name, value) => {
        const params = new URLSearchParams(location.search);
        params.set(name, value);
        history.push({pathname: location.pathname, search: params.toString()});
    }

    return (
        <Switch>
            <Route exact path="/bestellungen">
                {selectedYear && <Overview orders={orders} selectedYear={selectedYear} setSelectedYear={setSelectedYear}/>}
            </Route>
            <Route exact path="/bestellungen/bearbeiten/:orderId">
                <UpdateOrder orders={orders} adminView/>
            </Route>
        </Switch>
    )
}